import { createFileRoute, notFound } from "@tanstack/react-router";
import { hasPermission } from "@flint/api-contract";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { InvoiceDetailPage } from "../../../../features/invoices/detail/index.ts";
import { meQueryOptions } from "../../../../lib/session.ts";
import "../../../../features/invoices/detail/invoice-detail.css";

export const Route = createFileRoute("/(workspace)/sales/invoices/$invoiceId/")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null);
    const perms = me?.company?.permissions ?? [];
    if (!hasPermission(perms, "invoices.view")) {
      throw notFound();
    }
  },
  component: InvoiceDetailRoute,
});

function InvoiceDetailRoute() {
  const { invoiceId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Sales" },
        { label: "Invoices", to: "/sales/invoices" },
        { label: "Detail" },
      ]}
      // Detail pages render their own full-width composer-head + composer-foot
      // and constrain only the middle content to a max-width — see
      // `invoice-detail.css` `.detail-main` rules. Strip the shell's default
      // padding + max-width so the sticky bands span the viewport.
      viewportClassName="p-0 md:p-0"
      contentClassName="max-w-none"
    >
      <InvoiceDetailPage invoiceId={invoiceId} />
    </WorkspaceShell>
  );
}
